import React, { useEffect, useState } from 'react';
import Papa from 'papaparse';
import { fetchR2CsvText } from '../utils/fetchR2Csv';

export default function R2Probe({ onBack }) {
  const [rows, setRows] = useState(null);
  const [error, setError] = useState(null);
  const [ms, setMs] = useState(0);
  const key = 'public/data/Best Performing Linked/best_performing_rank_state_linked.csv';

  useEffect(() => {
    let cancelled = false;
    (async () => {
      const t0 = performance.now();
      try {
        const csvText = await fetchR2CsvText(key);
        if (cancelled) return;
        const parsed = Papa.parse(csvText, { header: true, dynamicTyping: true, skipEmptyLines: true });
        setRows(parsed.data);
        setMs(Math.round(performance.now() - t0));
      } catch (e) {
        if (cancelled) return;
        setError(e.message || 'Failed to load CSV');
      }
    })();
    return () => { cancelled = true; };
  }, []);

  return (
    <div style={{ padding: 24, maxWidth: 900, margin: '0 auto' }}>
      <button onClick={onBack} style={{ marginBottom: 12 }}>← Back</button>
      <h2>R2 CSV Probe</h2>
      <p style={{ color: '#546072' }}>Key: <code>{key}</code></p>
      {error && <div style={{ color: 'crimson' }}>Error: {error}</div>}
      {!error && !rows && <div>Loading…</div>}
      {!error && rows && (
        <div>
          <div style={{ marginBottom: 12 }}>Loaded {rows.length} rows in {ms} ms</div>
          <pre style={{ maxHeight: 280, overflow: 'auto', background: '#f7f7f9', padding: 12, borderRadius: 6 }}>
{rows.slice(0, 5).map((r, i) => JSON.stringify(r)).join('\n')}
          </pre>
        </div>
      )}
    </div>
  );
}


